import { Outlet, useLocation } from "react-router-dom";
import { SideBar } from "../Components/SideBar";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setConnectModal } from "../ReduxSlices/ModalSlice";
import { api } from "../Components/functions/Api";
import { setProfile } from "../ReduxSlices/AuthSlice";
// import Chatbot from "../Components/Chatbot/Chatbot";

export const setCurrentProfile = async (account, dispatch) => {
  const profile = await api("profile/getProfile", {
    walletAddress: account,
  });
  dispatch(setProfile(profile));
};

export const DashboardLayouts = () => {
  const account = useSelector((state) => state.auth.account);
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(false);

  const dispatch = useDispatch();
  const tryConnect = () => {
    dispatch(setConnectModal(true));
  };

  // Mobile detection
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 1024);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    if (account) setCurrentProfile(account, dispatch);
    else tryConnect();
  }, [account]);

  // Check if current route is host details page
  const isHostDetailsPage = location.pathname.includes('/dashboard/host/nfts/') && location.pathname.split('/').length > 4;

  return (
    <div className="flex w-full h-full">
      {/* Hide sidebar on mobile for host details page */}
      {!(isMobile && isHostDetailsPage) && <SideBar />}
      <div className="flex-1 overflow-hidden">
        <Outlet />
      </div>
      {/* <Chatbot/> */}
    </div>
  );
};
